import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Radios } from '@feathr/components';

import DonationFormsSelect from '../../DonationFormsSelect';

type TFormSelection = 'any' | 'specific';

function DonationFormSubmissionGoal(): JSX.Element {
  const { t } = useTranslation();
  const [selectMode, setSelectMode] = useState<TFormSelection>('any');
  const [selectedForms, setSelectedForms] = useState<string[]>([]);
  const {
    spacing: { '4': gap },
  } = useMantineTheme();

  function handleSelectMode(value?: string): void {
    if (!value) {
      return;
    }
    setSelectMode(value as TFormSelection);
  }

  const options = [
    { id: 'any', name: t('Any donation form submission') },
    { id: 'specific', name: t('Submissions on specific donation form(s)') },
  ];

  function handleFormSelection(value?: string[]): void {
    if (!value) {
      return;
    }
    setSelectedForms(value);
  }

  return (
    <Flex direction={'column'} gap={gap}>
      <Radios
        helpText={t('Choose which donation form submissions will be tracked as conversions.')}
        label={t('Donation form selection')}
        layout={'block'}
        onChange={handleSelectMode}
        options={options}
        value={selectMode}
      />
      {selectMode === 'specific' && (
        <DonationFormsSelect
          filters={{ state: 'published' }}
          isMulti={true}
          label={t('Donation form(s)')}
          onChange={handleFormSelection}
          placeholder={t('Start typing to search donation forms')}
          value={selectedForms}
        />
      )}
    </Flex>
  );
}

export default observer(DonationFormSubmissionGoal);
